import { DataResponse } from "shared/models";
import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const fraudDetectionService = createApi({
  reducerPath: "fraudDetectionService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getFraudRules: builder.query<DataResponse<any>, any>({
      query: (params) => ({
        url: `/fraud-rules?skip_log=${
          params?.skip_log ? params?.skip_log : false
        }`,
        method: "GET",
        headers: !params?.skip_log
          ? {
            PageName: "Fraud Detection Setting",
          }
          : {},
      }),
    }),
    updateFraudRule: builder.mutation<DataResponse<any>, any>({
      query: (body: any) => {
        return {
          url: `/fraud-rules/${body.id}`,
          body: body,
          params: { skip_log: body?.skip_log ? body?.skip_log : false },
          method: "PUT",
          headers: {
            PageName: "Fraud Detection Setting",
          },
        };
      },
    }),
    getActivityLogs: builder.query<any, { merchants: number[]; date_from?: string;
      date_to?: string; page: number; limit: number, sortBy: string, order: string }>({
      query: (params) => ({
        url: `/fraud/log`,
        method: "GET",
        headers: {
          PageName: "Fraud Detection Setting",
        },
        params: params,
      }),
    }),
    getActivityLogByMerchant: builder.query<any, { id: string }>({
      query: (params) => ({
        url: `/fraud/merchant-detail/${params?.id}`,
        method: "GET",
        headers: {
          PageName: "Fraud Detection Setting",
        },
      }),
    }),
    unblockMerchant: builder.mutation<DataResponse<any>, any>({
      query: (body: any) => {
        return {
          url: `/fraud/unblocking-merchant/${body.merchantId}`,
          body: body,
          params: { skip_log: body?.skip_log ? body?.skip_log : false },
          method: "PUT",
          headers: {
            PageName: "Fraud Detection Setting",
          },
        };
      },
    }),
  }),
});

export const {
  useGetFraudRulesQuery,
  useUpdateFraudRuleMutation,
  useGetActivityLogsQuery,
  useGetActivityLogByMerchantQuery,
  useUnblockMerchantMutation,
} = fraudDetectionService;
